import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Select from 'react-select';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const styles_select = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    container: (provided) => ({ ...provided }),
    control: (provided) => ({ ...provided, paddingTop: '5px', paddingBottom: '5px' }),
    valueContainer: (provided) => ({ ...provided, overflow: 'visible', marginTop: '10px' }),
    placeholder: (provided, state) => ({
        ...provided,
        position: 'absolute',
        top: state.hasValue || state.selectProps.inputValue ? -15 : '0%',
        transition: 'top 0.1s, font-size 0.1s',
        fontSize: (state.hasValue || state.selectProps.inputValue) && 13
    })
};

const tiposSucursal = [
    { value: 0, label: 'Fija' },
    { value: 1, label: 'Móvil' }
];

const FiltrosSucursal = ({ show, handleCerrar, filtros, handleAplicar }) => {

    const eventosListado = useSelector(state => state.eventos.listado);

    const [nombre, setNombre] = useState('');
    const [tipoData, setTipoData] = useState(null);
    const [eventoData, setEventoData] = useState(null);

    useEffect(() => {
        if (show) {
            setNombre(filtros.nombre || '');
            setTipoData(filtros.tipo !== null ? tiposSucursal.find(t => t.value === filtros.tipo) ?? null : null);
            const evOpc = eventosListado.map(e => ({ value: e._id, label: e.nombre }));
            setEventoData(filtros.evento ? evOpc.find(e => e.value === filtros.evento) ?? null : null);
        }
    }, [show]);

    const handleAplicarFiltros = () => {
        handleAplicar({
            nombre: nombre.trim(),
            tipo: tipoData ? tipoData.value : null,
            evento: eventoData ? eventoData.value : null
        });
        handleCerrar();
    };

    const handleLimpiar = () => {
        setNombre('');
        setTipoData(null);
        setEventoData(null);
        handleAplicar({ nombre: '', tipo: null, evento: null });
        handleCerrar();
    };

    const eventosOpciones = eventosListado.map(e => ({ value: e._id, label: e.nombre }));

    return (
        <Modal show={show} size="md" backdrop="static" centered onHide={handleCerrar}>
            <Modal.Header closeButton>
                <Modal.Title>Filtros</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row g-3">
                    <div className="col-6">
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Nombre"
                                id="filtro_nombre"
                                value={nombre}
                                onChange={e => setNombre(e.target.value)}
                            />
                            <label htmlFor="filtro_nombre">Nombre</label>
                        </div>
                    </div>
                    <div className="col-6 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Tipo"
                                options={tiposSucursal}
                                value={tipoData}
                                onChange={option => setTipoData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>
                    <div className="col-12 form-group">
                        <div className="input-group h-100">
                            <Select
                                className="select-group w-100"
                                classNamePrefix="react-select"
                                placeholder="Evento"
                                options={eventosOpciones}
                                value={eventoData}
                                onChange={option => setEventoData(option)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-outline-secondary me-auto" onClick={handleLimpiar}>
                    <i className="fas fa-times me-1"></i> Limpiar
                </button>
                <button className="btn btn-secondary" onClick={handleCerrar}>
                    Cancelar
                </button>
                <button className="btn btn-primary" onClick={handleAplicarFiltros}>
                    <i className="fas fa-filter me-1"></i> Aplicar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default FiltrosSucursal;
